import { BrandingIcon, MailIcon, SiteIcon, SMTPIcon, TagsIcon } from "allIcons";
import NotificationIcon from "allIcons/NotificationIcon";

export default function getSettingsMenu() {
  const { search } = window.location;
  return [
    search && {
      module: "general-settings",
      title: "accountSettings.menu.general",
      icon: <SiteIcon />,
    },
    {
      module: "branding-and-colors",
      title: "accountSettings.menu.brandingAndColors",
      icon: <BrandingIcon />,
    },
    {
      module: "smtp",
      title: "accountSettings.menu.SMTP",
      icon: <SMTPIcon />,
    },
    {
      module: "email-templates",
      title: "accountSettings.menu.emailTemplates",
      icon: <MailIcon />,
    },
    {
      module: "notifications",
      title: "accountSettings.menu.notifications",
      icon: <NotificationIcon />,
    },
    {
      module: "tags",
      title: "accountSettings.menu.tags",
      icon: <TagsIcon />,
    },
    // {
    //   module: "trash",
    //   title: "accountSettings.menu.trash",
    // icon: <TrashIcon />,
    // },
  ];
}
